var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogInInformationDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64457 17.4574C7.04248 15.3601 9.42927 13.9784 12.1388 13.9784C14.8483 13.9784 17.2351 15.3601 18.633 17.4574M12.7002 21.6682C12.3389 21.8077 11.9386 21.8077 11.5772 21.6682C8.75502 20.5617 6.33177 18.6304 4.6234 16.1263C2.91504 13.6221 2.00084 10.6614 2 7.63002V3.0598C2 2.64611 2.16434 2.24938 2.45685 1.95685C2.74938 1.66434 3.14611 1.5 3.5598 1.5H20.7176C21.1313 1.5 21.5281 1.66434 21.8205 1.95685C22.113 2.24938 22.2774 2.64611 22.2774 3.0598V7.61442C22.2798 10.6484 21.367 13.6126 19.6584 16.1198C17.9499 18.6271 15.5249 20.5606 12.7002 21.6682ZM12.1387 11.6387C14.077 11.6387 15.6483 10.0674 15.6483 8.12916C15.6483 6.19089 14.077 4.61961 12.1387 4.61961C10.2004 4.61961 8.62916 6.19089 8.62916 8.12916C8.62916 10.0674 10.2004 11.6387 12.1387 11.6387Z",
    stroke: "#252938",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogInInformationDarkblue);
export default __webpack_public_path__ + "static/media/Log-in-information-darkblue.1565f401.svg";
export { ForwardRef as ReactComponent };